import {
  updateContentMargin,
  modifyFeatureLineup,
  headerSearchBarFix,
  updateSocialWidgetPosition,
} from './utils/helpers';
import { updateMenuButton, setNavItemAttributes } from './utils/handleNavigation';
import updateHeaderItems from './utils/updateHeaderItems';

$(document).ready(function () {
  $('.generalmessage').prependTo('header');
  headerSearchBarFix('Search website...');
  updateMenuButton();
  modifyFeatureLineup();
  updateHeaderItems();

  $(globalThis).on('load', function () {
    updateContentMargin();
    setNavItemAttributes();
    updateSocialWidgetPosition();
  });
});
